module.exports = __webpack_public_path__ + "img/pointD_cardCoin.79400ff6.png";